import { api } from './client';

/** Hub de integraciones del negocio activo (estándar Codeus). Prefijo: /api/integraciones */

export type EstadoIntegracion = 'activa' | 'con_problemas' | 'sin_configurar';

export interface Integracion {
  id: string;
  nombre: string;
  paraQue: string;
  estado: EstadoIntegracion;
  resumen: string;
  configuracion: Array<{ nombre: string; valor: string }>;
  rutas: Array<{ dato: string; entraPor: string; vaA: string }>;
  campos: Array<{ origen: string; destino: string }>;
  monitor: Array<{ nombre: string; valor: string; alerta?: boolean }>;
  avisos: string[];
  configurarEn?: { ruta: string; etiqueta: string };
  registros: boolean;
}

export const getIntegraciones = () => api.get<Integracion[]>('/api/integraciones');

/** Baja los registros en CSV (con la sesión y el negocio activo, como cualquier pedido). */
export async function descargarRegistros(id: string, dias: 1 | 7 | 30): Promise<void> {
  const blob = await api.get<Blob>(`/api/integraciones/${id}/registros.csv`, { query: { dias }, blob: true });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${id}-${new Date().toISOString().slice(0, 10)}-${dias}d.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
